export default "__VITE_ASSET__BQRobwYL__"